/**
 * Ideation API endpoint client — T7.
 *
 * Wraps POST /api/runs/ideate with types from @malaberg/shared.
 * Cost is intentionally NOT exposed in IdeateResponse — writers don't see it.
 * It is recorded only in the `ideation_requests` audit table (system_owner only).
 */
import type { IdeateRequest, IdeateResponse } from '@malaberg/shared';
import { apiClient } from '../client';

export const ideationApi = {
  /**
   * POST /api/runs/ideate — generate AI-suggested brief variable sets.
   *
   * @param request - The ideation request payload (productId, market, optional direction/count/partialBrief)
   * @param opts.signal - Optional AbortSignal to cancel an in-flight request
   * @throws ApiError when the server responds with non-2xx
   * @returns Parsed response containing the ideas array (no cost field)
   */
  suggest(request: IdeateRequest, opts?: { signal?: AbortSignal }): Promise<IdeateResponse> {
    return apiClient.request<IdeateResponse>('POST', '/api/runs/ideate', {
      body: JSON.stringify(request),
      signal: opts?.signal,
    });
  },
};
